import { AxiosResponse } from 'axios';
import { api } from './base/api';
import { Result } from '../models/common/resultResponse';
import { IIntegrationCodeApi } from './base';
import { KeyValue } from '../models/common';
import { PaginationResponse } from '../models/common/paginationResponse';
import {
  IntegrationCodeRequest,
  IntegrationCodeSaveRequest
} from '../models/request';
import {
  IntegrationCodeEditedResponse,
  IntegrationCodeResponse
} from '../models/response';

const baseRoute: string = 'IntegrationCode';

export class IntegrationCodeApi extends IIntegrationCodeApi {
  domain(): Promise<AxiosResponse<Result<KeyValue>, any>> {
    return api.get(`${baseRoute}/integrationcodetypes`);
  }
  searchGrid(
    request: IntegrationCodeRequest
  ): Promise<AxiosResponse<PaginationResponse<IntegrationCodeResponse>, any>> {
    return api.get(`${baseRoute}/`, { params: request });
  }
  getIntegrationCodeByGuid(
    guidintegrationCodeRequest: string
  ): Promise<AxiosResponse<Result<IntegrationCodeEditedResponse>>> {
    return api.get(`${baseRoute}/getIntegrationCodeByGuid`, {
      params: { guidintegrationCodeRequest }
    });
  }
  saveIntegrationCode(
    request: IntegrationCodeSaveRequest
  ): Promise<AxiosResponse<Result<void>>> {
    return api.post(`${baseRoute}/save`, request);
  }
}

